<template>
  <button
    v-on:click="buttonClick"
    :disabled="disabled"
    class="add-to-cart-btn">
    <slot>{{ t('button') }}</slot>
  </button>
</template>

<script>
import store from '../../../vue/store'

export default {
  name: 'AdvButton',
  props: {
    productId: Number,
    quantity: Number,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    }
  },
  methods: {
    buttonClick () {
      this.$emit('btn-click')
      const productPrice = this.productData.productFinalPrice
      const barcode = this.productData.barCodes[0]
      const productQuantity = this.quantity

      const pixieEventOptions = {
        value: productPrice,
        currency: 'EUR',
        OrderID: barcode,
        Quantity: productQuantity
      }

      const taboolaEventOptions = {
        notify: 'event',
        name: 'add_to_cart',
        revenue: productPrice,
        orderid: barcode,
        currency: 'EUR',
        quantity: productQuantity
      }

      document.dispatchEvent(new CustomEvent('pixieAddToCart', {
        detail: {
          data: pixieEventOptions
        }
      }))

      document.dispatchEvent(new CustomEvent('taboolaAddToCart', {
        detail: {
          data: taboolaEventOptions
        }
      }))
    }
  }
}
</script>
